import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageIcon from '@mui/icons-material/Image';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArchiveIcon from '@mui/icons-material/Archive';
import GifIcon from '@mui/icons-material/Gif';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import EmailIcon from '@mui/icons-material/Email';
import CodeIcon from '@mui/icons-material/Code';

export const FileIcon = (mimeType) => {
    if (!mimeType) return <InsertDriveFileIcon color="primary" />;

    const [mainType, subType] = mimeType.split('/');

    switch (mainType) {
        case 'image':
            return <ImageIcon color="primary" />;
        case 'video':
            return <VideoFileIcon color="primary" />;
        case 'audio':
            return <AudioFileIcon color="primary" />;
        default:
            switch (mimeType) {
                case 'application/pdf':
                    return <PictureAsPdfIcon color="primary" />;
                case 'application/msword':
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                    return <TextSnippetIcon color="primary" />;
                case 'application/vnd.ms-excel':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    return <TableChartIcon color="primary" />;
                case 'application/zip':
                case 'application/x-zip-compressed':
                    return <ArchiveIcon color="primary" />;
                case 'application/x-rar-compressed':
                    return <ArchiveIcon color="primary" />;
                case 'image/gif':
                    return <GifIcon color="primary" />;
                case 'video/mp4':
                    return <VideoFileIcon color="primary" />;
                case 'audio/mpeg':
                    return <AudioFileIcon color="primary" />;
                case 'text/csv':
                    return <TableChartIcon color="primary" />;
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                    return <SlideshowIcon color="primary" />;
                case 'message/rfc822':
                    return <EmailIcon color="primary" />;
                case 'application/json':
                case 'application/javascript':
                case 'text/plain':
                case 'text/html':
                case 'text/css':
                    return <CodeIcon color="primary" />;
                default:
                    return <InsertDriveFileIcon color="primary" />;
            }
    }
};